<template>
  <!-- <div class="common-header width-1260">
    <div class="header-top" id="common-header"></div>
    <div class="header">
      <div class="logo"></div>
      <div v-if="myProject" class="mine-project">{{ "我的联采项目 >" }}</div>
    </div>
    <div></div>
  </div> -->

  <div class="common-header">
    <div class="new-header-component">
      <div class="header-main width-1260 d-flex flex-s-b flex-align-center">
        <div class="d-flex header-left">
          <span>您好，欢迎来到平方网</span>
          <template v-if="!userInfo.customerId">
            <a
              class="m-l-20 m-r-20 home-a cursor-pointer"
              @click="linkToTargetWeb(3)"
              >免费注册</a
            >
            <a class="m-r-20 cursor-pointer" @click="linkToTargetWeb(3)"
              >登录</a
            >
          </template>
        </div>

        <div class="header-right d-flex">
          <a class="m-r-20 home-a cursor-pointer" @click="linkToTargetWeb(0)"
            >平方网首页</a
          >
          <a class="m-r-20 cursor-pointer" @click="linkToTargetWeb(1)"
            >成功案例</a
          >
          <a class="m-r-20 cursor-pointer" @click="linkToTargetWeb(2)"
            >关于我们</a
          >
          <span class="m-r-20">服务专线 {{ servicePhone }}</span>
          <div class="m-r-20 d-flex" v-if="userInfo.customerId">
            <a
              v-if="userInfo.customerRole === '供应商'"
              @click="linkToWork('supplier')"
              class="m-r-20 cursor-pointer"
              >供应商工作台</a
            >
            <a
              v-else
              @click="linkToWork('purchaser')"
              class="m-r-20 cursor-pointer"
              >采购商工作台</a
            >
            <span
              >欢迎{{ userInfo.customerRole }}：{{
                userInfo.customerName
              }}</span
            >
            <span @click="logOut" class="logout-btn">退出</span>
          </div>
        </div>
      </div>
    </div>
    <div class="header width-1260">
      <div class="logo cursor-pointer" @click="backToHome"></div>
      <div
        v-if="myProject"
        class="mine-project cursor-pointer"
        @click="goMineProject"
      >
        <span class="font-w-600"> 我的联采项目 </span>
        <span class="icon icon-youjiantou font-14"></span>
      </div>
    </div>
  </div>
</template>
<script lang="js">
module.exports = require("./index.js");
</script>
<style lang="scss" scoped>
@import "./index";
</style>
